import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-matriculacion-atajo-modal',
  templateUrl: './matriculacion-atajo-modal.component.html',
  styleUrls: ['./matriculacion-atajo-modal.component.css']
})
export class MatriculacionAtajoModalComponent implements OnInit {

  matricualcionForm: FormGroup;
  show  = false;
  constructor(public diaalogRef: MatDialogRef<MatriculacionAtajoModalComponent>) { }

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void{
    this.matricualcionForm = new FormGroup({
      tipoTramite : new FormControl('', Validators.required),
      km : new FormControl(''),
      paisOrigen: new FormControl(''),
      numPedido: new FormControl('')

    });
  }
  changeEstado(event): void{
    console.log(event.value);
    switch (event.value){
      case ('MATRICULACION VEHICULO IMPORTACION'):
        this.show  = true;
        this.matricualcionForm.get('km').setValidators(Validators.required);
        this.matricualcionForm.get('paisOrigen').setValidators(Validators.required);
        this.matricualcionForm.get('km').enable();
        this.matricualcionForm.get('paisOrigen').enable();
        break;

      default:
        this.show = false;
        this.matricualcionForm.get('km').setValidators(null);
        this.matricualcionForm.get('paisOrigen').setValidators(null);
        this.matricualcionForm.get('km').disable();
        this.matricualcionForm.get('paisOrigen').disable();
        break;
    }
  }
}
